var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ObiButton',_vm._g(_vm._b({class:`dropdown-toggle obi-dropdown-${_vm.as}`,attrs:{"loading":_vm.isLoading}},'ObiButton',_vm.attrs,false),_vm.$listeners),[_c('ObiText',{attrs:{"as":"span"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }